/** @format */

import { Card, Col, Container, Row } from "react-bootstrap";
import ResumeUploader from "./resume-uploader";

const Resume = () => {
  return (
    <div id="content-page" className="content-inner">
      <Container>
        <Row className="justify-content-center">
          <Col lg="12">
            <ResumeUploader />
          </Col>

          <Col lg="12">
            <Card className="p-4 border border-light rounded-lg shadow-md">
              <div className="flex-1 p-4 border border-gray-200 rounded-lg">
                <h5 className="text-lg font-bold text-center">
                  Create your resume using your profile
                </h5>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Resume;
